import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { LoadingPane, PagedList, dateUtilities, ModalWindow, GenericError, SaveButton, accessibilityNotificationsEmitter } from '../../common';
import * as publishedActions from './published.actions';
import { modifyMessageActions } from '../modify-message';
import { tenantHelpers } from '../../tenantInfo';
import { toastr } from 'react-redux-toastr';
import './published.scss';

const modalText = (productName) => `Are you sure you want to close this notification? It will no longer appear when participants log into ${productName}.`;

export class PublishedComponent extends Component {


  componentDidMount() {
    const { publishedActions } = this.props;
    publishedActions.fetchList();
  }

  componentWillUpdate(nextProps, nextState) {
    const { publishedActions } = this.props;
    publishedActions.fetchList();
  }

  componentDidUpdate(prevProps, prevState) {
     const { selectedMessage : previousMessage } = prevProps;
     const { published } = this.props;
     const { pendingClosed } = published;
     const { showModal } = pendingClosed || {};
     if(showModal && !previousMessage) {
         var confirmDismiss = document.getElementById('save');
         if(confirmDismiss) confirmDismiss.focus();
    }
  }

  openConfirmModal(id) {
    const { publishedActions } = this.props;
    const { closeMessageShowModal } = publishedActions;
    accessibilityNotificationsEmitter.assertive(modalText(tenantHelpers.getProductName()));
    closeMessageShowModal(id);
  }

  handleCloseMessage(id) {
    const { publishedActions } = this.props;
    const { closeMessage, closeMessageCloseModal } = publishedActions;
    closeMessage(id)
      .then(val => {
        closeMessageCloseModal();
        toastr.success('Success', 'Notification Closed');
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  closeConfirmModal() {
    const { publishedActions } = this.props;
    const { closeMessageCloseModal } = publishedActions;
    closeMessageCloseModal();
  }

  handleEdit(id) {
    const { redirectTo } = this.props;
    redirectTo('/edit-message/' + id);
  }

  renderMessage(message) {
    const { id, content, publishAtUtc } = message || {};

    return (
      <tr key={id}>
        <td>{dateUtilities.getUserFriendlyFormatFromJson(publishAtUtc)}</td>
        <td className='message-content'>{content}</td>
        <td>
          <button
            className='btn btn-primary action-btn'
            aria-label='Edit Notification'
            onClick={e => this.handleEdit(id)}>
            <span className='glyphicon glyphicon-pencil'/>
          </button>
          <button
            id={'buttonClose_' + id}
            className='btn btn-primary action-btn'
            aria-label='Close Notification'
            onClick={e => this.openConfirmModal(id)}>
            <span className='glyphicon glyphicon-ban-circle'/>
          </button>
        </td>
      </tr>);
  }

  render() {
    const { published, publishedActions } = this.props;
    const { changePageNumber } = publishedActions;
    const { pagingData, listState, closingMessages, pendingClosed } = published;
    const { itemsPerPage } = pagingData || {};
    const { isFetching, err, data } = listState || {};
    const { messageId, showModal } = pendingClosed || {};

    //confirm deleting modal
    var isModalSaving;
    if(!!showModal) {
      const modalMessage = closingMessages.get(messageId);
      isModalSaving = modalMessage && modalMessage.isFetching;
    }


    var messageList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(data) {
      messageList = data.results;
      currentPage = data.currentPage;
      totalItemsCount = data.totalResults;
    }

    const headers = (
      <tr>
        <th>PUBLISHED DATE</th>
        <th>MESSAGE</th>
        <th>ACTIONS</th>
      </tr>
    );

    const titleContents = "Close Notification";
    const footerContents =
      <div>
        <SaveButton
          id="save"
          text={"Yes"}
          saving={isModalSaving}
          onSave={e => this.handleCloseMessage(messageId)}/>
        <button id="close" className="btn btn-default" onClick={e => this.closeConfirmModal()}>
          No
        </button>
      </div>

    const modal =
    <ModalWindow
      show={showModal}
      title={titleContents}
      footer={footerContents}
      onClose={e => this.closeConfirmModal()}
    >
      <GenericError err={err}/>

      <div className="form-horizontal survey">
        <p>{modalText(tenantHelpers.getProductName())}</p>
      </div>
    </ModalWindow>

    return (
      <div id='published-messages'>
        <LoadingPane
          isLoading={isFetching}
          err={err}
          loadingMessage={'Loading published notifications...'}
          contentLoadedMessage={'Published notifications loaded.'}>
          <PagedList
            header={headers}
            items={messageList}
            emptyMessage={<p>No Published Notifications Found</p>}
            mapItem={message => this.renderMessage(message)}
            currentPage={currentPage}
            resultsPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            changePageNumber={page => changePageNumber(page)}
            isLoading={isFetching} />
            {modal}
        </LoadingPane>
      </div>
    );
  }
}

PublishedComponent.propTypes = {

};

const mapStateToProps = ({ published }) => {
  return {
    published
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    publishedActions: bindActionCreators(publishedActions, dispatch),
    modifyMessageActions: bindActionCreators(modifyMessageActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PublishedComponent);
